/**
 * Pijl voor de inklapknop rechtsboven in een paneel. Een getekende pijl in
 * plaats van het teken "◂": dat blijft in het systeemlettertype klein, ook bij
 * een grotere tekstmaat.
 */
export function PanelCollapseIcon() {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 16 16"
      className="h-4 w-4"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M10 3 5 8l5 5" />
    </svg>
  );
}
